export type AppRoute =
  | 'diary'
  | 'records'
  | 'people'
  | 'person'
  | 'mbti'
  | 'pathway'
  | 'fitness'
  | 'nutrition'
  | 'energy'
  | 'gamification'
  | 'settings'
  | 'users'
  | 'profile'
  | 'pan-spirit'
  | 'mine'
  | 'health'
  | 'wellness'
  | 'mind'
  | 'intellect'
  | 'goals'
  | 'missions'
  | 'exam';

export interface NavigationEntry {
  route: AppRoute;
  params?: Record<string, unknown>;
}

export const ROUTE_ALIASES: Record<string, AppRoute> = {
  '': 'diary',
  '/': 'diary',
  '/diary': 'diary',
  '/home': 'diary',
  '/records': 'records',
  '/people': 'people',
  '/person': 'person',
  '/mbti': 'mbti',
  '/pathway': 'pathway',
  '/fitness': 'fitness',
  '/nutrition': 'nutrition',
  '/energy': 'energy',
  '/gamification': 'gamification',
  '/settings': 'settings',
  '/users': 'users',
  '/profile': 'profile',
  '/pan-spirit': 'pan-spirit',
  '/mine': 'mine',
  '/health': 'health',
  '/wellness': 'wellness',
  '/mind': 'mind',
  '/intellect': 'intellect',
  '/goals': 'goals',
  '/missions': 'missions',
  '/exam': 'exam',
};

export type ViewMode = Exclude<AppRoute, 'person' | 'profile' | 'users'>;
export const fullscreenRoutes = new Set<AppRoute>([
  'users',
  'profile',
  'settings',
  'mbti',
  'fitness',
  'nutrition',
  'energy',
  'health',
  'missions',
  'wellness',
  'mind',
  'intellect',
  'exam',
  'goals',
]);
export const hasOwnHeader = (route: AppRoute) =>
  ['pathway', 'pan-spirit', 'mine', 'people'].includes(route);
const keys = [
  'personId',
  'taskId',
  'record',
  'pathwayId',
  'category',
  'intent',
  'date',
  'filter',
  'compose',
  'tab',
  'section',
  'goalId',
  'dimension',
  'recordKey',
] as const;
export function parseRoute(hash: string): NavigationEntry {
  const [rawPath, query = ''] = hash.replace(/^#/, '').split('?');
  const normalized = ('/' + rawPath.replace(/^\//, '')).replace(/\/$/, '') || '/';
  const knownRoute = Object.prototype.hasOwnProperty.call(ROUTE_ALIASES, normalized);
  const route = knownRoute ? ROUTE_ALIASES[normalized] : 'diary';
  const search = new URLSearchParams(query);
  const params: Record<string, unknown> = {};
  if (knownRoute)
    for (const key of keys) {
      const value = search.get(key);
      if (value === null || value.length > 300) continue;
      if (key === 'record') params.record = value === 'true';
      else if (key === 'personId' || key === 'goalId') {
        const id = Number(value);
        if (Number.isSafeInteger(id) && id > 0) params[key] = id;
      } else params[key] = value;
    }
  // A bare person route cannot render a meaningful detail page.
  if (route === 'person' && !params.personId) return { route: 'people' };
  return Object.keys(params).length ? { route, params } : { route };
}
export function routeHash(entry: NavigationEntry): string {
  const search = new URLSearchParams();
  for (const key of keys) {
    const value = entry.params?.[key];
    if (typeof value === 'string' || typeof value === 'boolean' || typeof value === 'number')
      search.set(key, String(value));
  }
  return (
    (entry.route === 'diary' ? '#/' : `#/${entry.route}`) + (search.toString() ? `?${search}` : '')
  );
}
